<template>
  <SogCard>
    <SogCardTitle>Prämie/Anzahl</SogCardTitle>
    <SogCardContent>
      <SogForm
        v-show="_current.shoppingCartItem.productPrice?.isStoreExportBlank"
      >
        Anzahl: {{ _current.shoppingCartItem.count }}
      </SogForm>
      <SogForm>
        <SogFormField width="200px">
          <SogNumericTextBox
            v-show="_current.shoppingCartItem.productPrice?.isJustInTime"
            ref="_eCount"
            v-model="_current.shoppingCartItem.count"
            placeholder="Anzahl"
            format="n"
            width="150px"
            :min="1"
          />
        </SogFormField>
        <SogFormField>
          <SogNumericTextBox
            v-model="_current.shoppingCartItem.grossPrice"
            placeholder="Prämie inkl VersSt., €"
            format="n2"
            :min="_minPremium"
            width="150px"
            :step="0.5"
          />
        </SogFormField>
        <SogFormField v-show="_isInvoiced">
          Abrechnungsbetrag:
          <SogDataLabel
            :value="_current.shoppingCartItem.amount"
            :value-type="SogDataLabelValueType.Money"
          />
        </SogFormField>
      </SogForm>
    </SogCardContent>
    <SogCardActions>
      <SogCardActionButton
        mdi-icon="mdi-cart-plus"
        @click="onAddItem"
      >
        In den Einkaufswagen
      </SogCardActionButton>
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">

import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";


const _shoppingCartStore = useShoppingCartStore();
const _accountStore = useAccountStore();

const {currentItem: _current, currentShoppingCart} = storeToRefs(_shoppingCartStore);

const _isBranch = computed(() => {
  return _accountStore.person && _accountStore.person.isBranch();
});

const _minPremium = computed(() => {
  return _current.value.shoppingCartItem.minGrosPrice;
  return _isBranch.value ? 0 : _current.value.shoppingCartItem.minGrosPrice;
});

const _isInvoiced = computed(() => {
  return currentShoppingCart.value.isInvoiced;
});

async function onAddItem() {
  if (
    _current.value.shoppingCartItem.minGrosPrice &&
    _current.value.shoppingCartItem.minGrosPrice >
    _current.value.shoppingCartItem.grossPrice
  ) {
    notificationService.error("Prämie ist zu niedrig.");
    return;
  }

  await _shoppingCartStore.addItem();
}


</script>

<style scoped>

</style>
